export const convertLocalDate = (data) => new Date(data).toLocaleDateString();
